import { render, staticRenderFns } from "./diet-calendar.vue?vue&type=template&id=21ab0cf8&scoped=true&"
import script from "./diet-calendar.vue?vue&type=script&lang=js&"
export * from "./diet-calendar.vue?vue&type=script&lang=js&"
import style0 from "./diet-calendar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./diet-calendar.vue?vue&type=style&index=1&id=21ab0cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab0cf8",
  null
  
)

export default component.exports